import type { Catalog } from "./en";

export const es: Catalog = {
  "common.retry": "Reintentar",
  "common.reload": "Recargar",
  "common.save": "Guardar",
  "common.saving": "Guardando…",
  "common.saved": "Guardado",
  "common.saveFailed": "No se pudo guardar",
  "common.saveChanges": "Guardar cambios",
  "common.delete": "Eliminar",
  "common.remove": "Quitar",
  "common.cancel": "Cancelar",
  "common.edit": "Editar",
  "common.openLink": "Abrir",
  "common.back": "← Volver",
  "common.loading": "Cargando",
  "common.loadingMore": "Cargando…",
  "common.sending": "Enviando…",
  "common.error": "Algo salió mal",
  "common.failed": "Error",
  "common.name": "Nombre",
  "common.email": "Correo electrónico",
  "common.title": "Título",
  "common.language": "Idioma",

  "time.now": "ahora",
  "time.lessThanMinute": "<1 min",
  "time.minutes": "{n} min",
  "time.hours": "{n} h",
  "time.days": "{n} d",

  "nav.inbox": "Bandeja de entrada",
  "nav.faq": "Centro de ayuda",
  "nav.reports": "Informes",
  "nav.settings": "Ajustes",
  "layout.workspace": "Espacio de trabajo",
  "layout.newWorkspace": "+ Nuevo espacio de trabajo",
  "layout.signOut": "Cerrar sesión",

  "app.unreachable.title": "No se puede conectar con el servidor",
  "app.unreachable.body": "Comprueba tu conexión y vuelve a intentarlo.",
  "app.noWorkspaces.title": "Aún no hay espacios de trabajo",
  "app.noWorkspaces.body": "Pide a un administrador que te invite a un espacio de trabajo.",

  "error.pane": "No se pudo mostrar esta conversación.",
  "error.tryAgain": "Volver a intentarlo",
  "error.body": "Esta pantalla tuvo un error inesperado.",
  "error.goInbox": "Ir a la bandeja de entrada",

  "login.title": "Inicia sesión en Soporte",
  "login.sent": "Si {email} tiene acceso, recibirá un enlace para iniciar sesión. Caduca en 15 minutos.",
  "login.intro": "Te enviaremos por correo un enlace de acceso de un solo uso.",
  "login.email": "Correo del trabajo",
  "login.sendFailed": "No se pudo enviar el enlace. Vuelve a intentarlo en un minuto.",
  "login.submit": "Enviarme un enlace",
  "verify.incomplete": "Este enlace está incompleto.",
  "verify.failed": "No se pudo iniciar sesión.",
  "verify.expired": "Enlace caducado",
  "verify.signingIn": "Iniciando sesión…",
  "verify.newLink": "Solicitar un enlace nuevo",

  "newWs.superAdminOnly": "Solo los superadministradores pueden crear espacios de trabajo.",
  "newWs.created": "Espacio de trabajo creado",
  "newWs.copySecret": "Copia ahora el secreto de identidad. Solo se muestra una vez (puedes rotarlo más tarde).",
  "newWs.secretLabel": "Secreto de identidad (solo servidor)",
  "newWs.continue": "Continuar con la configuración",
  "newWs.createFailed": "No se pudo crear el espacio de trabajo",
  "newWs.title": "Nuevo espacio de trabajo",
  "newWs.intro": "Un espacio de trabajo por app o producto. Cada uno tiene su propio centro de ayuda, bandeja de entrada y claves.",
  "newWs.submit": "Crear espacio de trabajo",

  "reports.period": "Periodo",
  "reports.lastDays": "Últimos {count} días",
  "reports.loadFailed": "No se pudo cargar el informe.",
  "reports.conversations": "Conversaciones",
  "reports.resolved": "Resueltas",
  "reports.medianReply": "Mediana de primera respuesta",
  "reports.satisfaction": "Satisfacción",
  "reports.ratingsCount": "{count} valoraciones",
  "reports.ratingsCount.one": "{count} valoración",
  "reports.ratingsCount.other": "{count} valoraciones",
  "reports.ratings": "Valoraciones",
  "reports.barLabel": "{count} valoraciones de {score}",
  "reports.barLabel.one": "{count} valoración de {score}",
  "reports.barLabel.other": "{count} valoraciones de {score}",
  "reports.recentComments": "Comentarios recientes",
  "reports.noComments": "Aún no hay comentarios.",

  "status.open": "Abiertas",
  "status.pending": "Pendientes",
  "status.resolved": "Resueltas",

  "inbox.title": "Bandeja de soporte",
  "inbox.conversations": "Conversaciones",
  "inbox.liveStopped": "Las actualizaciones en directo se han detenido.",
  "inbox.notifyPrompt": "Recibe un aviso en el escritorio con los mensajes nuevos.",
  "inbox.enableNotifications": "Activar notificaciones",
  "inbox.notNow": "Ahora no",
  "inbox.statusFilter": "Estado",
  "inbox.assignee": "Asignado a",
  "inbox.all": "Todas",
  "inbox.mine": "Mías",
  "inbox.unassigned": "Sin asignar",
  "inbox.loadFailed": "No se pudieron cargar las conversaciones.",
  "inbox.empty.open": "No hay conversaciones abiertas 🎉",
  "inbox.empty.pending": "No hay conversaciones pendientes 🎉",
  "inbox.empty.resolved": "No hay conversaciones resueltas 🎉",
  "inbox.you": "Tú",
  "inbox.agent": "Agente",
  "inbox.attachment": "📎 Adjunto",
  "inbox.unreadCount": "{count} sin leer",
  "inbox.loadMoreFailed": "No se pudieron cargar más conversaciones",
  "inbox.loadMore": "Cargar más",
  "inbox.select": "Selecciona una conversación",
  "inbox.visitor": "Visitante {id}",

  "contact.aria": "Contacto",
  "contact.verified": "✓ Usuario verificado",
  "contact.anonymous": "Visitante anónimo",
  "contact.userId": "ID de usuario",
  "contact.lastSeen": "Última vez",
  "contact.started": "Iniciada",
  "contact.rating": "Valoración",

  "event.resolved": "resuelta",
  "event.reopened": "reabierta",
  "event.assigned": "asignada",
  "event.csat_request": "valoración solicitada",
  "event.auto_reply": "respuesta automática",

  "sys.resolved": "Marcada como resuelta",
  "sys.reopened": "Reabierta",
  "sys.assigned": "Asignada a {name}",
  "sys.csat_request": "Valoración solicitada",
  "sys.auto_reply": "Respuesta automática: {body}",

  "thread.aria": "Conversación",
  "thread.verified": "Usuario verificado",
  "thread.you": "{name} (tú)",
  "thread.reopen": "Reabrir",
  "thread.snooze": "Posponer",
  "thread.snoozeTitle": "Esperando al cliente",
  "thread.resolve": "Resolver",
  "thread.liveStopped": "Las actualizaciones en directo de esta conversación se han detenido.",
  "thread.loadFailed": "No se pudo cargar esta conversación.",
  "thread.loadEarlier": "Cargar anteriores",
  "thread.loadEarlierFailed": "No se pudieron cargar los mensajes anteriores",
  "thread.failedRetry": "Error: reintentar",
  "thread.typing": "{name} está escribiendo…",
  "thread.seen": "Visto",
  "thread.updateFailed": "No se pudo actualizar",

  "composer.uploadFailed": "No se pudo subir el archivo",
  "composer.savedReplies": "Respuestas guardadas",
  "composer.placeholder": "Responder a {name}… (escribe / para respuestas guardadas)",
  "composer.reply": "Respuesta",
  "composer.attach": "📎 Adjuntar",
  "composer.uploading": "Subiendo…",
  "composer.removeFile": "Quitar {name}",
  "composer.send": "Enviar",

  "faq.untitled": "(sin título)",
  "faq.loadFailed": "No se pudo cargar el centro de ayuda.",
  "faq.loadFailedToast": "No se pudo cargar el centro de ayuda",
  "faq.notFound": "Artículo no encontrado.",
  "faq.backToList": "Volver al centro de ayuda",
  "faq.intro": "Los artículos aparecen en el centro de ayuda de la app y se sugieren antes de que los clientes inicien un chat.",
  "faq.newArticle": "Nuevo artículo",
  "faq.categories": "Categorías",
  "faq.categoriesIntro": "Agrupa los artículos por temas. Los títulos van por idioma.",
  "faq.addCategoryFailed": "No se pudo añadir la categoría",
  "faq.newCategoryPlaceholder": "Título de la nueva categoría ({locale})",
  "faq.addCategory": "Añadir categoría",
  "faq.noArticles": "Aún no hay artículos. Empieza por tu pregunta más frecuente.",
  "faq.uncategorized": "Sin categoría",
  "faq.languages": "Idiomas",
  "faq.views": "Vistas",
  "faq.helpful": "Útil",
  "faq.helpfulValue": "{percent} % de {votes}",
  "faq.published": "Publicado",
  "faq.draft": "Borrador",
  "faq.missing": "Falta",
  "faq.categoryTitle": "Título ({locale})",
  "faq.saveCategoryFailed": "No se pudo guardar la categoría",
  "faq.categorySaved": "Categoría guardada",
  "faq.deleteCategoryConfirm": "¿Eliminar esta categoría? Sus artículos quedarán sin categoría.",
  "faq.deleteCategoryFailed": "No se pudo eliminar la categoría",
  "faq.addTitleFirst": "Añade primero un título",
  "faq.deleteArticleConfirm": "¿Eliminar este artículo en todos los idiomas?",
  "faq.deleteArticleFailed": "No se pudo eliminar el artículo",
  "faq.category": "Categoría",
  "faq.titlePlaceholder": "¿Cómo puedo…?",
  "faq.untitledExisting": "Añade un título para {locale} o quita abajo la traducción {locale}.",
  "faq.untitledNew": "Añade un título para {locale} o vacía el texto para dejar fuera este idioma.",
  "faq.slug": "Slug de la URL",
  "faq.slugHint": "Déjalo vacío para generarlo a partir del título.",
  "faq.body": "Texto (Markdown)",
  "faq.bodyHint": "Admite **negrita**, *cursiva*, listas, enlaces, imágenes y `código`. El HTML se muestra como texto.",
  "faq.publishedIn": "Publicado en {locale}",
  "faq.removeTranslation": "Quitar la traducción {locale}",
  "faq.preview": "Vista previa",
  "faq.untitledPreview": "Sin título",

  "settings.tab.general": "General",
  "settings.tab.hours": "Horario de atención",
  "settings.tab.install": "Instalación",
  "settings.tab.push": "Notificaciones push",
  "settings.tab.team": "Equipo",
  "settings.tab.canned": "Respuestas guardadas",
  "settings.adminOnly": "Solo los administradores del espacio de trabajo pueden cambiar estos ajustes.",
  "settings.loadFailed": "No se pudieron cargar los ajustes.",
  "settings.reloadFailed": "No se pudieron recargar los ajustes",

  "general.branding": "Marca",
  "general.brandingIntro": "Cómo se ven el centro de ayuda y el chat dentro de tu app.",
  "general.brandColor": "Color de marca",
  "general.brandColorPicker": "Selector del color de marca",
  "general.brandColorHex": "Color de marca en hex",
  "general.logoUrl": "URL del logotipo",
  "general.logoHint": "Imagen HTTPS que se muestra arriba en el centro de ayuda.",
  "general.languages": "Idiomas",
  "general.languagesIntro": "La interfaz sigue el idioma del dispositivo cuando está activado aquí; los artículos recurren al idioma predeterminado.",
  "general.defaultLanguage": "Idioma predeterminado",
  "general.greeting": "Saludo ({locale})",
  "general.greetingHint": "Déjalo vacío para usar el saludo integrado.",
  "general.csatTitle": "Valoraciones de satisfacción",
  "general.csatAsk": "Pedir a los clientes que valoren la conversación cuando se resuelva",

  "hours.intro": "Fuera de este horario, los clientes ven que no estás disponible y reciben tu respuesta automática.",
  "hours.enable": "Usar horario de atención (si no, siempre aparecerás en línea)",
  "hours.timezone": "Zona horaria",
  "hours.open": "Abierto",
  "hours.closed": "Cerrado",
  "hours.opens": "Apertura del {day}",
  "hours.closes": "Cierre del {day}",
  "hours.replyTitle": "Tiempo de respuesta y respuesta automática",
  "hours.typical": "Tiempo de respuesta habitual (minutos)",
  "hours.typicalHint": "Se muestra a los clientes mientras estás en línea. Déjalo vacío para ocultarlo.",
  "hours.away": "Mensaje de ausencia ({locale})",
  "hours.awayHint": "Se envía automáticamente cuando alguien escribe fuera del horario de atención (como mucho una vez cada 12 h por conversación).",

  "install.keys": "Claves",
  "install.publishableKey": "Clave pública",
  "install.publishableHint": "Puedes incluirla sin riesgo en tu app y tu web.",
  "install.identitySecret": "Secreto de identidad",
  "install.secretHint": "Guárdalo en tu servidor. Úsalo para firmar los ID de usuario y vincular los chats a usuarios con sesión iniciada.",
  "install.secretHidden": "Oculto. Rotarlo invalida al instante los hashes de usuario existentes.",
  "install.rotateConfirm": "¿Rotar el secreto de identidad? Tu servidor debe usar el nuevo secreto de inmediato.",
  "install.rotateFailed": "No se pudo rotar el secreto",
  "install.rotate": "Rotar secreto",
  "install.origins": "Sitios web permitidos",
  "install.originsIntro": "Orígenes que pueden usar el widget web (uno por línea, p. ej., https://app.example.com). Usa * para permitir cualquiera. Las apps móviles no lo necesitan.",
  "install.saveOrigins": "Guardar orígenes",
  "install.reactWeb": "React (web)",
  "install.anyWebsite": "Cualquier sitio web",
  "install.verifyUsers": "Verificar usuarios (en el servidor)",
  "install.verifyIntro": "Calcula el hash del usuario en tu servidor y envíalo junto con el ID de usuario.",

  "push.fcmTitle": "Android (Firebase Cloud Messaging)",
  "push.fcmIntro": "Sube el JSON de una cuenta de servicio de Firebase con permiso de Cloud Messaging.",
  "push.fcmFile": "JSON de la cuenta de servicio de Firebase",
  "push.saveFcm": "Guardar credenciales de FCM",
  "push.apnsTitle": "iOS (Apple Push Notification service)",
  "push.apnsIntro": "Crea una clave de autenticación de APNs (.p8) en tu cuenta de desarrollador de Apple.",
  "push.p8File": "Archivo de clave .p8",
  "push.keyId": "ID de clave",
  "push.teamId": "ID de equipo",
  "push.saveApns": "Guardar credenciales de APNs",
  "push.configured": "Configurado el {date}",
  "push.notConfigured": "Sin configurar",

  "team.invite": "Invitar a un compañero",
  "team.inviteIntro": "Recibirá un correo con un enlace para iniciar sesión.",
  "team.role": "Rol",
  "team.role.agent": "Agente",
  "team.role.admin": "Administrador",
  "team.sendInvite": "Enviar invitación",
  "team.inviteSent": "Invitación enviada",
  "team.inviteNoEmail": "Añadido. No se envió ningún correo: esta dirección ha recibido varios correos de acceso hace poco. Puede usar uno de ellos.",
  "team.inviteFailed": "No se pudo enviar la invitación",
  "team.members": "Miembros",
  "team.loadFailed": "No se pudieron cargar los miembros.",
  "team.loadFailedToast": "No se pudieron cargar los miembros",
  "team.online": "en línea",
  "team.removeConfirm": "¿Quitar a {name}? Sus conversaciones quedarán sin asignar.",
  "team.removeFailed": "No se pudo quitar al miembro",

  "canned.intro": "Escribe {shortcut} en el cuadro de respuesta para insertar una. Usa {name} para el nombre del cliente y {agent} para el tuyo.",
  "canned.shortcut": "Atajo",
  "canned.shortcutHint": "letras minúsculas, números y guiones",
  "canned.message": "Mensaje",
  "canned.empty": "Aún no hay respuestas guardadas. Crea una y luego escribe su /atajo en el cuadro de respuesta para insertarla.",
  "canned.new": "Nueva respuesta guardada",
  "canned.deleteConfirm": "¿Eliminar la respuesta guardada /{shortcut}?",
  "canned.deleteFailed": "No se pudo eliminar la respuesta guardada",
  "canned.loadFailed": "No se pudieron cargar las respuestas guardadas.",
  "canned.loadFailedToast": "No se pudieron cargar las respuestas guardadas",
};
